/**
 * THE major-catalyst rule (simulation design choice, not a claim about real markets):
 *   majorCatalyst = author is the simulated Elon OR simulated Trump account (by stable id)
 *                   AND the post itself visibly carries image media.
 * Used by scenario generation, the market (runner regime / KOL showcase gating) and game judging.
 * Quote posts qualify only via media on the quoting post itself, authored by a special account.
 */
import type { Tweet } from './types';

export const SPECIAL_IDS = ['sim-elon', 'sim-trump'] as const;
export function isMajorCatalyst(post: Pick<Tweet, 'author' | 'image'> & Partial<Tweet> | null | undefined): boolean {
  if (!post) return false;
  return (SPECIAL_IDS as readonly string[]).includes(post.author.id) && post.image != null && (Number.isFinite(post.image.seed) || !!post.image.upload);
}
